import { connect } from 'react-redux';
import ExecutiveList from '../components/ExecutiveList/ExecutiveList';
import * as actions from '../redux/actions/ExecutiveList';
import { getUser as getUserSelector } from '../redux/selectors/accountSettingSelector';
import { getUser } from '../redux/actions/AccountSetting';
import { postSalesforceSync, getSalesforceConfig } from '../redux/actions/Salesforce';
import { getIndustryCategoryList } from '../redux/actions/IndustryCategory';
import { getLetterOrderList } from '../redux/actions/LetterOrderList';
import { getFollowCallOrderList } from '../redux/actions/FollowCallOrder';
import { getResearchedTelHasDepartments } from '../redux/actions/CorporationTelResearch';
import { goBack, replace, push } from 'react-router-redux';
import { IP_CHECK_TYPE } from '../constants/IpConstants';
import { postIpCheck } from '../redux/actions/Ip';
import { isEnableKLOperatorAdvancedSearch } from '../utils/userOptionUtils';

const mapStateToProps = (state) => ({
  user: getUserSelector(state),
  executiveList: state.executiveList.executiveList.toIndexedSeq().toArray(),
  exportedList: state.executiveList.exportedList,
  pageInfo: state.executiveList.pageInfo,
  isLoading: state.executiveList.isLoading,
  overwrite: state.executiveList.overwrite,
  filters: state.executiveList.filters.toIndexedSeq().toArray(),
  isLoadingFilter: state.executiveList.isLoadingFilter,
  isPostingFilter: state.executiveList.isPostingFilter,
  deletingFilterId: state.executiveList.deletingFilterId,
  patchingFilterId: state.executiveList.patchingFilterId,
  message: state.executiveList.message,
  errorMessage: state.executiveList.errorMessage,
  shortMessage: state.executiveList.shortMessage,
  showInfoBox: state.executiveList.showInfoBox,
  showBanner: state.executiveList.showBanner,
  routerInfo: state.router.location,
  corporationCount: state.executiveList.corporationCount,
  executiveListItem: state.executiveDetail.item,
  isLoadingExecutiveListItem: state.executiveDetail.isLoading,
  parentCorporationKeymanList: state.executiveDetail.parentCorporationKeymanList,
  isLoadingParentCorporationKeymanList: state.executiveDetail.isLoadingParentCorporationKeymanList,
  parentCorporationKeymanListTotal: state.executiveDetail.parentCorporationKeymanListTotal,
  childCorporationKeymanList: state.executiveDetail.childCorporationKeymanList,
  isLoadingChildCorporationKeymanList: state.executiveDetail.isLoadingChildCorporationKeymanList,
  childCorporationKeymanListTotal: state.executiveDetail.childCorporationKeymanListTotal,
  isLoadingCsv: state.executiveList.isLoadingCsv,
  overview: state.letterOrderList.overview,
  tags: state.executiveList.tags,
  selectedAddressTags: state.executiveList.selectedAddressTags,
  isLoadingSelectedAddressTags: state.executiveList.isLoadingSelectedAddressTags,
  isLoadingSidebar: state.executiveList.isLoadingSidebar,
  isDeletingTags: state.executiveList.isDeletingTags,
  isUpdatingTags: state.executiveList.isUpdatingTags,
  isImporting: state.salesforce.isImporting,
  exe_export_mappings_flag: state.salesforce.exe_export_mappings_flag,
  isPostingSalesforceSync: state.executiveList.isPostingSalesforceSync,
  hasLetterOrderHistoryNames: state.executiveList.hasLetterOrderHistoryNames,
  duplicateNames: state.executiveList.duplicateNames,
  selectExecutivePerson: state.executiveList.selectExecutivePerson,
  isLoadingCheck: state.executiveList.isLoadingCheck,
  enableExecutiveListAdvancedSearch: state.executiveList.executiveListAdvancedSearchIpCheck || isEnableKLOperatorAdvancedSearch(getUserSelector(state)),
  executiveListAdvancedSearchIpCheckLoading: state.executiveList.executiveListAdvancedSearchIpCheckLoading,
  letterOrderList: state.letterOrderList.letterOrderList,
  followCallOrderList: state.followCallOrder.followCallOrderList,
  researchedTelHasDepartmentKeys: state.corporationTelResearch.departmentKeys,
  industryCategoryList: state.industryCategory.industryCategoryList,
  aiSearchResponse: state.executiveList.aiSearchResponse,
  isLoadingAttackList: state.executiveList.isLoadingAttackList,
  attackListTag: state.executiveList.attackListTag,
  attackListExtractedConditions: state.executiveList.attackListExtractedConditions,
  attackListSummary: state.executiveList.attackListSummary,
  attackListTaggedCount: state.executiveList.attackListTaggedCount,
  attackListError: state.executiveList.attackListError,
  // 2段階API
  isAnalyzingUrl: state.executiveList.isAnalyzingUrl,
  isExecutingTagging: state.executiveList.isExecutingTagging,
  attackListAnalysisId: state.executiveList.attackListAnalysisId,
})

const mapDispatchToProps = dispatch => ({
  getExecutiveList(data, overwrite) {
    dispatch(actions.getExecutiveList(data, overwrite))
  },

  getExecutiveListById(id, data) {
    dispatch(actions.getExecutiveListById(id, data))
  },

  postSendExecutiveList(data) {
    dispatch(actions.postSendExecutiveList(data));
  },

  postExecutiveListSearch(data, overwrite) {
    dispatch(actions.postExecutiveListSearch(data, overwrite))
  },

  postNoMatchCorporationCsv(data) {
    dispatch(actions.postNoMatchCorporationCsv(data))
  },

  postExecutiveListCopyLog(data) {
    dispatch(actions.postExecutiveListCopyLog(data))
  },

  postExecutiveListSearchAi(prompt, includeWebDiscovery) {
    return dispatch(actions.postExecutiveListSearchAi(prompt, includeWebDiscovery))
  },

  postExecutiveListBuildConditionsAi(prompt) {
    return dispatch(actions.postExecutiveListBuildConditionsAi(prompt))
  },

  getWebCandidateKeymen(corporateNumber) {
    return dispatch(actions.getWebCandidateKeymen(corporateNumber))
  },

  getAiWebResult(token) {
    return dispatch(actions.getAiWebResult(token))
  },

  clearExecutiveList() {
    dispatch(actions.clearExecutiveList())
  },

  getExecutiveListFilters() {
    dispatch(actions.getExecutiveListFilters());
  },

  getIndustryCategoryList() {
    dispatch(getIndustryCategoryList());
  },

  postExecutiveListFilters(data) {
    dispatch(actions.postExecutiveListFilters(data));
  },

  patchExecutiveListFiltersById(id, data) {
    dispatch(actions.patchExecutiveListFiltersById(id, data));
  },

  deleteExecutiveListFiltersById(id) {
    dispatch(actions.deleteExecutiveListFiltersById(id));
  },

  setShowInfoBox(value) {
    dispatch(actions.setShowInfoBox(value));
  },

  setShowBanner(value) {
    dispatch(actions.setShowBanner(value));
  },

  postExecutiveListCsv(data) {
    dispatch(actions.postExecutiveListCsv(data));
  },

  getUserInfo() {
    dispatch(getUser());
  },

  postIpCheck() {
    dispatch(postIpCheck(IP_CHECK_TYPE.KL_OPERATOR_ADVANCED_EXECUTIVE_LIST_SEARCH));
  },

  getExportedList(data) {
    dispatch(actions.getExportedList(data));
  },

  goBack() {
    dispatch(goBack());
  },

  replace(url, state) {
    dispatch(replace(url, state));
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  postExecutiveListGetTags(data, isAllTags, overwrite) {
    dispatch(actions.postExecutiveListGetTags(data, isAllTags, overwrite));
  },

  postExecutiveListDeleteTags(data) {
    dispatch(actions.postExecutiveListDeleteTags(data));
  },

  postExecutiveListUpdateTagName(data) {
    dispatch(actions.postExecutiveListUpdateTagName(data));
  },

  postExecutiveListUpdateTag(data) {
    dispatch(actions.postExecutiveListUpdateTag(data));
  },

  postSalesforceSync() {
    dispatch(postSalesforceSync());
  },

  getSalesforceConfig() {
    dispatch(getSalesforceConfig());
  },

  postExecutiveListSalesforceSync(data) {
    dispatch(actions.postExecutiveListSalesforceSync(data));
  },

  getLetterOrderList(data, overwrite) {
    dispatch(getLetterOrderList(data, overwrite));
  },

  getFollowCallOrderList(data, overwrite) {
    dispatch(getFollowCallOrderList(data, overwrite));
  },

  getResearchedTelHasDepartments(data) {
    dispatch(getResearchedTelHasDepartments(data));
  },

  // 2段階API
  postAttackListAnalyzeUrl(data) {
    dispatch(actions.postAttackListAnalyzeUrl(data));
  },

  postAttackListExecuteTagging(data) {
    dispatch(actions.postAttackListExecuteTagging(data));
  },

  clearAttackListState() {
    dispatch(actions.clearAttackListState());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ExecutiveList);



// WEBPACK FOOTER //
// ./src/containers/ExecutiveList.js